import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Recaptcha from '@components/application/input/recaptcha';

const AdditionalView = ({
  dealbuilder,
  loading,
  recaptchaSiteKey,
  updateCustomerDetails,
  sendEnquiry,
}) => {
  const [message, setMessage] = useState('');
  const recaptcha = useRef('');

  const updateComments = (event) => {
    setMessage(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    recaptcha.current.validate() &&
      updateCustomerDetails(
        {
          comments: message,
          'g-recaptcha-response':
            window.grecaptcha && window.grecaptcha.getResponse(),
        },
        sendEnquiry
      );
  };

  return (
    <div className="db-modal__content ac-animation--fade-in-from-right">
      <form onSubmit={handleSubmit}>
        <section className="db-section">
          <p className="db-question">Other information</p>
          <p className="ch-mb--4 ch-fs--3 ch-color--grey-6">
            We&apos;ll pass any messages on to one of our Product Consultants.
          </p>
          <div className="ch-form__group">
            <label
              className="ch-form__control-label"
              htmlFor="enquiry-comments"
            >
              Your message{' '}
              <span className="ch-color--grey-6 ch-fw--400">(Optional)</span>
            </label>
            <textarea
              className="ch-form__control"
              id="enquiry-comments"
              name="enquiry[comments]"
              onChange={updateComments}
            />
          </div>

          <Recaptcha
            className="g-recaptcha"
            errorMessage="Please complete the reCAPTCHA."
            recaptchaSiteKey={recaptchaSiteKey}
            ref={recaptcha}
          />
        </section>
        <section className="db-section db-section--cta">
          <button
            className={classNames('ch-btn ch-btn--block ch-btn--cta', {
              'ac-btn--loading': loading,
            })}
            type="submit"
          >
            Send your {dealbuilder && 'deal'} enquiry
          </button>
        </section>
      </form>
    </div>
  );
};

export default AdditionalView;

AdditionalView.propTypes = {
  dealbuilder: PropTypes.bool,
  loading: PropTypes.bool,
  recaptchaSiteKey: PropTypes.string,
  sendEnquiry: PropTypes.func,
  updateCustomerDetails: PropTypes.func,
};
